import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '@/context/AuthContext';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f9fafb;
`;

const Card = styled.div`
  background: white;
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);
  width: 100%;
  max-width: 380px;
`;

const Title = styled.h2`
  margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
  margin: 0 0 24px 0;
  color: #6b7280;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 16px;
  font-size: 14px;
`;

const Button = styled.button`
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  cursor: pointer;
`;

const Login: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(usernameOrEmail, password);
      toast.success('Login realizado com sucesso');
      navigate('/', { replace: true });
    } catch (error: any) {
      toast.error(error?.message || 'Falha no login');
    } finally {
      setLoading(false);
    }
  };

  return (
    isAuthenticated ? <Navigate to="/" replace /> : (
    <Container>
      <Card>
        <Title>Entrar</Title>
        <Subtitle>Acesse o sistema de relatórios</Subtitle>
        <form onSubmit={handleSubmit}>
          <Label>Usuário ou E-mail</Label>
          <Input
            type="text"
            value={usernameOrEmail}
            onChange={(e) => setUsernameOrEmail(e.target.value)}
            placeholder="admin ou admin@empresa.com"
            required
          />

          <Label>Senha</Label>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Sua senha"
            required
          />

          <Button type="submit" disabled={loading}>{loading ? 'Entrando...' : 'Entrar'}</Button>
        </form>
      </Card>
    </Container>
    )
  );
};

export default Login;


